import React from 'react';
import { useLanguage } from '../hooks/useLanguage';
import { content } from '../data/content';
import { Section } from './ui/Section';
import { Reveal } from './ui/Reveal';
import { Icon } from './ui/Icon';

const GROUP_ICONS = ['cloud', 'server', 'code', 'shield'];

export const TechStack = () => {
  const { language } = useLanguage();
  const t = content[language];

  return (
    <Section
      id="stack"
      eyebrow={t.stack.eyebrow}
      title={t.stack.title}
      subtitle={t.stack.subtitle}
      align="center"
      className="bg-app"
    >
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {t.stack.groups.map((g, i) => (
          <Reveal key={g.label} delay={80 * i}>
            <div
              className="rounded-3xl border bg-surface p-6 h-full lift"
              style={{ borderColor: 'var(--border)' }}
            >
              <div className="flex items-center gap-3">
                <span
                  className="inline-flex items-center justify-center h-9 w-9 rounded-xl bg-elev text-app"
                  style={{ border: '1px solid var(--border)' }}
                >
                  <Icon name={GROUP_ICONS[i]} size={16} />
                </span>
                <h3 className="text-sm font-semibold text-app">{g.label}</h3>
              </div>
              <ul className="mt-5 flex flex-wrap gap-1.5">
                {g.items.map((it) => (
                  <li
                    key={it}
                    className="chip text-app"
                    title={it}
                  >
                    {it}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
};

export default TechStack;
